export default __webpack_public_path__ + "static/media/trash-can-delete-icon.67e63b61.svg";